import { AppShell } from '@mantine/core';
import { createExportReportShifts } from 'features/export-report-shifts';
import { createShiftReportRegistry } from 'entities/shift';
import { shiftsReportPageModel } from '../../model';
import cls from './shifts-report-page.module.scss';

const ShiftReportRegistry = createShiftReportRegistry(shiftsReportPageModel.shiftRegistryModel);

const ExportShiftsReport = createExportReportShifts(shiftsReportPageModel.exportReportShiftsModel);

export const ShiftsReportPage = () => (
	<AppShell.Main className={cls.shiftsReportPage}>
		<ShiftReportRegistry topBarActionSlot={<ExportShiftsReport />} />
	</AppShell.Main>
);
